import { z } from 'zod';
import { idSchema, isoDateTime, platformSchema } from './common.js';
export const conversationKind = z.enum(['comment', 'mention', 'dm', 'reply']);
export const conversationSchema = z.object({
    id: idSchema,
    project_id: idSchema,
    connection_id: idSchema,
    platform: platformSchema,
    kind: conversationKind,
    external_thread_id: z.string(),
    post_id: idSchema.nullable(),
    participant_handle: z.string(),
    participant_avatar_url: z.string().url().nullable(),
    last_message_at: isoDateTime,
    unread: z.boolean(),
    assigned_to: idSchema.nullable(),
    status: z.enum(['open', 'resolved', 'spam']),
});
export const messageSchema = z.object({
    id: idSchema,
    conversation_id: idSchema,
    direction: z.enum(['inbound', 'outbound']),
    author_handle: z.string(),
    body: z.string(),
    external_id: z.string().nullable(),
    created_at: isoDateTime,
});
export const replyInput = z.object({
    body: z.string().min(1).max(10000),
});
//# sourceMappingURL=inbox.js.map